module.exports = __webpack_public_path__ + "img/cari_stt.3c3377ef.svg";